export default "__VITE_ASSET__2b1712e4__"